const user = {
  state: {
    profile: {},
  },

  /*  eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    SAVE_USER(state, payload) {
      state.profile = payload;
    },
  },

  getters: {
    uid: state => state.profile.uid,
    fullname() {
      const defaultName = 'User';
      return defaultName;
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js